<template>
	<div>
		<BaseActionBar
			v-if="isAdmin"
			:items="actions"
		>
			<template #header-info>
				<div class="manual-synced">
					<div><em>Last synced:</em> Synced by system | {{ status.lastSyncedAt }}</div>
					<div>
						<em>Sync status:</em>
						<template v-if="isSyncing || isLoading">
							Syncing…
						</template>
						<template v-else>
							Completed
						</template>
					</div>
				</div>
			</template>
		</BaseActionBar>

		<CRow>
			<CCol>
				<CInput
					v-model="query.keyword"
					:placeholder="$t('placeholder.stock_online_stock')"
					@keyup.enter="onInputEnter"
				>
					<template #prepend-content>
						<FontAwesomeIcon :icon="['far', 'search']" />
					</template>
				</CInput>
			</CCol>
		</CRow>

		<BaseTable
			:is-loading="isLoading"
			:pagination="pagination"
			:fields="CHANNEL_RULE_TABLE_FIELDS"
			:items="tableData"
			:hide-columns="['id']"
			name-route="AlocationChannelSingle"
			striped
			hover
			fixed
			clickable-rows
			class="table-custom"
			@onPaginationClick="handlePageChange"
			@onRowClick="handleRowClick"
		>
			<template #no-items-view>
				<div class="empty-table-element">
					<p class="subtitle">
						{{ $t('message.notFoundAllocationChannels') }}
					</p>
				</div>
			</template>

			<template #status="{item}">
				<CBadge
					class="badge-status"
					:color="getColorStatus(item ? CBADGE_COLORS.SUCCESS : CBADGE_COLORS.DANGER)"
				>
					{{ getTextStatus(item ? CBADGE_COLORS.SUCCESS : CBADGE_COLORS.DANGER) }}
				</CBadge>
			</template>
		</BaseTable>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { cleanObject, cloneDeep } from '../helpers/utils';
import { getColorStatus, getTextStatus } from '../helpers/cbadgeUtils';
import { CHANNEL_RULE_TABLE_FIELDS } from '../enums/allocation';
import { ROUTER_NAME } from '../enums/router';
import { CBADGE_COLORS } from '../enums/cbadgeColors';

export default {
	name: 'AllocationChannelList',

	data() {
		return {
			CBADGE_COLORS,
			CHANNEL_RULE_TABLE_FIELDS,
			query: {
				page: this.$route.query.page,
				keyword: this.$route.query.keyword,
				sort_by: 'created_at',
				sort_direction: 'desc',
			},
		};
	},

	computed: {
		...mapState('channelRuleList', {
			isLoading: 'isLoading',
			pagination: 'pagination',
			status: 'status',
		}),
		...mapGetters({
			tableData: 'channelRuleList/tableData',
			isAdmin: 'me/isAdmin',
		}),
		actions() {
			return [
				{
					onClick: () => {
						this.handleReSyncClick();
					},
					color: 'light',
					text: this.$t('button.syncAllocation'),
					disabled: this.isSyncing || this.isLoading,
				},
				//* hide for case club
				// {
				// 	to: { name: ROUTER_NAME.ALOCATION_CHANNEL_CREATE },
				// 	icon: ['far', 'plus'],
				// 	color: 'secondary',
				// 	text: this.$t('button.createAllocationRole'),
				// },
			];
		},
		isSyncing() {
			return this.status.message === 'syncing' || this.status.message === 'prepare_to_finish';
		},
	},
	created() {
		this.fetchData();
	},

	methods: {
		getTextStatus,
		getColorStatus,
		...mapActions({
			showToast: 'toast/showToast',
			getChannelRules: 'channelRuleList/getChannelRules',
			getReSyncAllocationChannels: 'channelRuleList/getReSyncAllocationChannels',
			postReSyncAllocationChannels: 'channelRuleList/postReSyncAllocationChannels',
		}),
		async fetchData() {
			await this.getReSyncAllocationChannels();
			await this.getChannelRules({
				...this.query,
			});
		},
		handleRowClick(id) {
			this.$router.push({ name: ROUTER_NAME.ALOCATION_CHANNEL_SINGLE, params: { id } });
		},
		handlePageChange(pageNum) {
			this.query.page = pageNum;
			this.updateUrl();
		},
		onInputEnter(e) {
			this.query.keyword = e.target.value;
			this.query.page = null;
			this.updateUrl();
		},
		updateUrl() {
			const query = cleanObject(cloneDeep(this.query));
			this.$router.push({ query }).catch(() => {});
		},
		async handleReSyncClick() {
			try {
				await this.postReSyncAllocationChannels();
				await this.fetchData();
				this.showToast({
					content: this.$t('toast.reSyncAllocationChannel'),
					header: 'Success',
					type: 'success',
				});
			} catch {
				this.showToast({
					content: this.$t('error.unexpectedError'),
					header: 'Unable to re-sync',
					type: 'danger',
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	.manual-synced {
		color: $color-black-45;
		font-size: rem($font-size-label);
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;

		em {
			color: $color-black-90;
			font-style: normal;
		}
	}
</style>
